// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"640":"d1cfb7bf","787":"d38d49d4"}[chunkId] + ".chunk.js";
};